module.exports = __webpack_public_path__ + "img/uus_avaleht_2.b2830c52.jpeg";